import { render } from "./CostiRicaviCarteSottoProgetto.vue?vue&type=template&id=7ab66498&scoped=true&ts=true"
import script from "./CostiRicaviCarteSottoProgetto.vue?vue&type=script&lang=ts"
export * from "./CostiRicaviCarteSottoProgetto.vue?vue&type=script&lang=ts"

import "./CostiRicaviCarteSottoProgetto.vue?vue&type=style&index=0&id=7ab66498&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ab66498"]])

export default __exports__